export enum Status {
  GOOD = 'GOOD',
  MEDIUM = 'MEDIUM',
  UNKNOWN = 'UNKNOWN',
  BAD = 'BAD',
  BLOCKED = 'BLOCKED'
}
